import Text from "@afa-shared/afa-components/dist/Text";
import Message from "@components/Message/Message";
import { ReactNode } from "react";

interface IFormErrorFeedback {
  messageHeading?: string;
  messageChildren?: ReactNode;
  messagePreset?: string;
}

const FormErrorFeedback = ({
  messageHeading,
  messageChildren,
  messagePreset,
}: IFormErrorFeedback) => {
  let heading: string = "Ett fel har inträffat";
  let text: ReactNode = (
    <Text
      variant="paragraph"
      children={
        "Vi kunde inte skicka iväg ditt meddelande på grund av att ett tekniskt fel har inträffat. Var vänlig försök igen senare."
      }
    />
  );

  if (messagePreset) {
    switch (messagePreset) {
      case "contactForm":
        heading = "";
        text = (
          <>
            <Text
              variant="paragraph"
              children={
                "Vi kunde inte skicka iväg ditt meddelande på grund av att ett tekniskt fel har inträffat."
              }
            />
            <Text
              variant="paragraph"
              children={`Kontakta kundcenter istället på telefonnummer 0771-88 00 99. Öppettider: vardagar klockan 8 - 17.`}
            />
          </>
        );
        break;
      case "eServicesEmployerForm":
        heading = "";
        text = (
          <>
            <Text
              variant="paragraph"
              children={
                "Vi kunde inte skicka iväg ditt meddelande på grund av att ett tekniskt fel har inträffat."
              }
            />
            <Text
              variant="paragraph"
              children={`Kontakta kundcenter istället på telefonnummer 08-696 49 49. Öppettider: vardagar klockan 8 - 17.`}
            />
          </>
        );
        break;
    }
  } else {
    if (messageHeading) heading = messageHeading;
    if (messageChildren) text = messageChildren;
  }

  return <Message heading={heading} headingVariant={"h2"} type={"error"} children={text} />;
};

export default FormErrorFeedback;
